/**
 * <RefreshButton> — la flèche « Rafraîchir » d'une barre de titre (molecule).
 *
 * Un `<IconButton>` transparent, à la couleur de l'univers, qui tourne DANS son bouton pendant la
 * relecture (`refreshing`) : c'est l'action qui a sa roue, jamais le contenu (§ Chargements). Écrit
 * une fois pour que chaque page garde le même nom accessible.
 */
import React from "react"

import { IconButton } from "../../atoms/Buttons/IconButton"

/** Sa cible, en px — le squelette d'une barre de titre réserve la même place. */
export const REFRESH_BUTTON_SIZE = 40

export type RefreshButtonProps = {
    /** La relecture est en cours : la roue remplace la flèche, le bouton ne répond plus. */
    refreshing: boolean
    onRefresh: () => void
}

export function RefreshButton({ refreshing, onRefresh }: RefreshButtonProps) {
    return (
        <IconButton
            iconName="sync-alt"
            appearance="transparent"
            iconColor="primary"
            size={REFRESH_BUTTON_SIZE}
            loading={refreshing}
            onPress={onRefresh}
            accessibilityLabel="Rafraîchir"
        />
    )
}
